import { ReduxUtils } from '../dependencies';

const modulePrefix = 'auth/';

export default ReduxUtils.strictObjectAccess({
    LOGIN_FORM: `${modulePrefix}LOGIN_FORM`,
    SIGN_UP_FORM: `${modulePrefix}SIGN_UP_FORM`,
    SET_DATA_ANALYSIS_PERSMISSION: `${modulePrefix}SET_DATA_ANALYSIS_PERSMISSION`,
});
